import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {createStore} from 'vuex'
import createdPersistedState from "vuex-persistedstate"
import jQuery from 'jquery'

localStorage.setItem("urlFile", "https://decoban.ir/project_decoran/uploads/");


const store = createStore({
    state() {
        return {
            my_profile: null,
            check_orders: true,
            message: true,

            products: {
                comparison_product: {},
            },

            filter: {
                products: null,
                advertising: null,
                product_store: null,
                consultants: null,
            },


            // **************************************************************

            order: {
                //ADD 'order_count_select' to products **
                products: [],
                orders_count: 0,
                orders_price: 0,
                orders_all_price: 0,
                orders_profit: 0,
            }

        }
    },
    mutations: {

        set_comparison_products(state, new_value) {

            state.products.comparison_product = new_value

        },

        set_filter_products(state, new_value) {

            if (new_value == 'delete') {
                state.filter.products = null
            } else {
                state.filter.products = new_value
            }

        },

        set_filter_products_store(state, new_value) {

            if (new_value == 'delete') {
                state.filter.product_store = null
            } else {
                state.filter.product_store = new_value
            }

        },

        set_filter_advertising(state, new_value) {

            if (new_value === 'delete') {
                state.filter.advertising = null
            } else {
                state.filter.advertising = new_value
            }

        },

        set_filter_consultants(state, new_value) {

            if (new_value == 'delete') {
                state.filter.consultants = null
            } else {
                state.filter.consultants = new_value
            }

        },

        set_my_profile(state, new_value) {

            state.my_profile = new_value

        },

        set_check_orders(state, new_value) {

            state.check_orders = new_value

        },

        set_message(state, new_value) {

            state.message = new_value

        },

        empty_state() {

            store.replaceState({

                check_orders: true,

                products: {
                    comparison_product: {},
                },

                filter: {
                    products: null,
                    advertising: null,
                },

                // **************************************************************

                order: {
                    //ADD 'order_count_select' to products **
                    products: [],
                    orders_count: 0,
                    orders_price: 0,
                    orders_all_price: 0,
                    orders_profit: 0,
                    information: null,
                }

            })

        },


        // ************************************  سبد خرید  *******************************************

        ProductUpdate(state, newValue) {
            if (state.order.products.length > 0) {

                let found = newValue.is_variable > 0 ? state.order.products.find(item => item.variable_id === newValue.variable_id) : state.order.products.find(item => item.id === newValue.id)

                if (found) {
                    found.order_count_select = newValue.order_count_select
                    found.count = newValue.count
                    found.price = newValue.price
                    found.off_price = newValue.off_price
                    if (found.order_count_select === 0) {
                        store.commit('ProductDelete', found)
                    }
                } else {
                    store.commit('ProductPush', newValue)
                }

            } else {
                store.commit('ProductPush', newValue)
            }

            var orders_count = 0
            store.state.order.products.forEach((item) => {
                orders_count = orders_count + item.order_count_select
            })
            store.state.order.orders_count = orders_count

            var orders_price = 0
            store.state.order.products.forEach((item) => {
                if (item.off_price !== null) {
                    orders_price = orders_price + parseInt(item.off_price) * parseInt(item.order_count_select)
                } else {
                    orders_price = orders_price + parseInt(item.price) * parseInt(item.order_count_select)
                }
            })
            store.state.order.orders_price = orders_price

            var orders_all_price = 0
            store.state.order.products.forEach((item) => {
                orders_all_price = orders_all_price + parseInt(item.price) * parseInt(item.order_count_select)
            })
            store.state.order.orders_all_price = orders_all_price


            let orders_profit = 0
            orders_profit = parseInt(store.state.order.orders_all_price) - parseInt(store.state.order.orders_price)
            store.state.order.orders_profit = orders_profit

        },

        ProductPush(state, newValue) {
            newValue.order_count_select = 1
            state.order.products.push(newValue)
        },

        ProductDelete(state, newValue) {
            try {
                newValue.is_variable > 0 ? state.order.products.find((item, index) => {
                    if (item.variable_id === newValue.variable_id) state.order.products.splice(index, 1);

                }) : state.order.products.find((item, index) => {

                    if (item.id === newValue.id) state.order.products.splice(index, 1);
                })

            } catch (e) {
                console.log(e.message)
            }
        },

        EmptyBasket(state) {
            state.order.products = [];
            state.order.orders_count = 0;
            state.order.orders_price = 0;
            state.order.orders_all_price = 0;
            state.order.orders_profit = 0;
            state.order.information = null;
        },

        set_information_orders(state , newValue){
            if (newValue === 'delete')
            {
                state.order.information = null
            }else
            {
                state.order.information = newValue
            }
        },

    },

    plugins: [createdPersistedState()]

})

import "vuetify/styles";
import {createVuetify} from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {aliases, fa} from 'vuetify/iconsets/fa'
import {mdi} from 'vuetify/iconsets/mdi';

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            fa,
            mdi,
        },
    },

});

import "../src/assets/css/bootstrap/css/bootstrap.min.css";
import "../src/assets/css/style.css";

// localStorage.clear()
// store.commit('empty_state')


if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        }).catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
    });
}


import SwiperCore from "swiper";
import {Autoplay, Pagination , Navigation} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './registerServiceWorker'

SwiperCore.use([Autoplay, Pagination , Navigation]);


const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(store);
app.use(jQuery);
app.mount("#app");
